<div class="app-container">
  <page-header [icon]="'far-exchange'" [title]="'product.moves'">
    <ng-container class="header-button">
      <app-exports [entity]="'hs-product-move-packs'" data-cy="exports"></app-exports>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters"
      (onSubmit)="filter()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [isExportButtonShown]="true"
      [entity]="'hs-product-move-packs'"
    >
      <div class="row">
        <div class="col-sm-4 col-md-2">
          <div class="form-group d-flex flex-column">
            <label>{{ 'stock.load.type' | translate }}:</label>
            <!--            todo: check if clearFilters for depots needed at all-->
            <!--            <select class="form-control" [(ngModel)]="filters.operationType" (change)="clearFilters('depots')">-->
            <select class="form-control" [(ngModel)]="filters.operationType">
              <option *ngFor="let type of operationTypes" value="{{ type }}">{{ type | translate }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-select
            [label]="'depot'"
            [icon]="null"
            [options]="depots"
            [(model)]="filters.depot"
            [dataCyAttribute]="'depot-to-filter'"
          ></form-row-select>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-select
            [label]="'products.checkouts'"
            [icon]="null"
            [options]="checkouts"
            [(model)]="filters.checkout"
            [isSelectDisabled]="filters.operationType === 'transfer'"
            [title]="''"
          ></form-row-select>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-select
            [label]="'createdBy'"
            [icon]="null"
            [options]="users"
            [optionKey]="'id'"
            [optionKeyText]="'name'"
            [(model)]="filters.createdBy"
          ></form-row-select>
        </div>

        <div class="col-sm-4 col-md-2">
          <form-row-input
            [label]="'date.from'"
            [icon]="null"
            [inputType]="'date'"
            [(model)]="filters.dateFrom"
          ></form-row-input>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-input
            [label]="'date.to'"
            [icon]="null"
            [inputType]="'date'"
            [(model)]="filters.dateTo"
          ></form-row-input>
        </div>
      </div>
    </app-filter-form>

    <app-base-listing
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="productMovePacks"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      (reloadList)="filter(1)"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
      (handleSelectedItem)="scrollService.save('selectedItem', $event)"
    ></app-base-listing>
  </section>
</div>
